module.exports = __webpack_public_path__ + "img/iso.fbc574fc.svg";